<template>
  <el-dialog title="律师审核" :append-to-body="true" :visible.sync="visible" :show-close="false" width="700px" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click.stop="cancelModal"><i
      class="el-dialog__close el-icon el-icon-close"></i></button>
    <el-form :model="lawyer" size="small" :rules="rules" ref="lawyerForm">
      <el-form-item label="姓名" label-width="80px" prop="name">
        {{lawyer.name}}
        <!--<el-input v-model="lawyer.name" autocomplete="off" style="width: 200px;"></el-input>-->
      </el-form-item>
      <!--<el-form-item label="性别" label-width="120px">-->
        <!--<el-input v-model="lawyer.gender" autocomplete="off"></el-input>-->
      <!--</el-form-item>-->
      <el-form-item label="律师证编号" label-width="80px">
        {{lawyer.code}}
      <!--<el-input v-model="lawyer.code" autocomplete="off"></el-input>-->
    </el-form-item>
      <!--<el-form-item label="所属律所" label-width="80px" prop="practicingInstitution">-->
        <!--<el-input v-model="lawyer.practicingInstitution" autocomplete="off"></el-input>-->
      <!--</el-form-item>-->
      <el-form-item label="所属律协" label-width="80px" prop="associationId">
        <!--<el-input v-model="lawyer.associationId" autocomplete="off"></el-input>-->
        <template>
          <el-select :value="valueTitle" :clearable="clearable" @clear="clearHandle">
            <el-option :value="valueTitle" :label="valueTitle" class="options">
              <el-tree style="padding-left: 10px"
                id="tree-option"
                ref="selectTree"
                :accordion="accordion"
                :data="options"
                :props="props"
                :node-key="props.value"
                :default-expanded-keys="defaultExpandedKey"
                @node-click="handleNodeClick">
              </el-tree>
            </el-option>
          </el-select>
        </template>
      </el-form-item>
      <!--<el-form-item label="邮箱" label-width="80px">-->
        <!--<el-input v-model="lawyer.email" autocomplete="off"></el-input>-->
      <!--</el-form-item>-->
      <!--<el-form-item label="审核" label-width="80px">-->
        <!--<el-select  style="width:100px" v-model="lawyer.register">-->
          <!--<el-option label="待审核" value="1"></el-option>-->
          <!--<el-option label="通过审核" value="0"></el-option>-->
          <!--<el-option label="拒绝" value="2"></el-option>-->
        <!--</el-select>-->
      <!--</el-form-item>-->
      <!--<el-form-item label="照片" label-width="80px">-->
        <!--<el-upload-->
          <!--class="upload-demo"-->
          <!--action="/_/video/uploadLecturerPhoto"-->
          <!--:on-success="upLoadSuccess"-->
          <!--:file-list="fileList"-->
          <!--list-type="picture">-->
          <!--<div class="el-upload__text"><i class="el-icon-upload" style="font-size: 18px"></i><span>上传</span></div>-->
        <!--</el-upload>-->
      <!--</el-form-item>-->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="loading" type="primary" :loading="true"></el-button>
      <el-button v-else type="primary" @click="passCheck('lawyerForm')">审核通过</el-button>
      <el-button v-if="loading1" type="primary" :loading="true"></el-button>
      <el-button v- v-else type="primary" @click="noPass('lawyerForm')">审核不通过</el-button>
    </div>
  </el-dialog>
</template>
<script>
import lawyer from '@/api/lawyer'
import association from '@/api/association'
import store from '../../../store/index'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    values: {
      type: Number,
      required: false,
      default: null
    },
    /* 配置项 */
    props:{
      type: Object,
      default:()=>{
        return {
          value:'id',             // ID字段名
          label: 'name',         // 显示名称
          children: 'children'    // 子级字段名
        }
      }
    },
    /* 选项列表数据(树形结构的对象数组) */
    options:{
      type: Array,
      default: ()=>{ return [
        {
        id:1,
        pid:2,
        name: '省律协',
        children: [{
          id:2,
          pid:2,
          name: '郑州市律协',
          children: [{
            id:3,
            pid:2,
            name: '金水区律协',
          }]
        }, {
          id:4,
          pid:2,
          name: '新乡律协',
          children: [{
            id:5,
            pid:2,
            name: '辉县律协',
          }]
        }]
      }
      ] }
    },
    /* 初始值 */
    value:{
      type: Number,
      default: ()=>{ return null }
    },
    /* 可清空选项 */
    clearable:{
      type:Boolean,
      default:()=>{ return true }
    },
    /* 自动收起 */
    accordion:{
      type:Boolean,
      default:()=>{ return false }
    },
    /* 配置项 */
    props:{
      type: Object,
      default:()=>{
        return {
          value:'id',             // ID字段名
          label: 'name',         // 显示名称
          children: 'children'    // 子级字段名
        }
      }
    },
    /* 选项列表数据(树形结构的对象数组) */
    options:{
      type: Array,
      default: ()=>{ return [] }
    },
    /* 初始值 */
    value:{
      type: Number,
      default: ()=>{ return null }
    },
    /* 可清空选项 */
    clearable:{
      type:Boolean,
      default:()=>{ return true }
    },
    /* 自动收起 */
    accordion:{
      type:Boolean,
      default:()=>{ return false }
    }
  },
  data () {
    return {
      loading: false,
      loading1: false,
      // 律师
      lawyer: {
        id: null,
        name: '',
        associationId: '',
        code: '',
        email: '',
        createdBy: '',
        register: ''
      },
      rules: {
        associationId: [
          {required: true, trigger: 'blur'},
        ]
      },
      valueId: null,    // 初始值
      valueTitle: '',
      defaultExpandedKey: [],
      fileList: [],
      adminName: ''
    }
  },
  mounted(){
      this.valueId = this.value,    // 初始值
      this.initHandle()
  },
  methods: {
    initForm () {
      this.lawyer = {
        }
      if (this.$refs.lawyer) {
        this.$refs.lawyer.resetFields()
      }
    },
    cancelModal () {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit('update:visible', false)
    },
    reload () {
      // 树形数据
      association.find({name: ''}).then(res => {
        let list = res.data.data[0]
        this.options = []
        this.options.push(list)
      })
      if (this.values !== null) {
        // 查找律师详情
        lawyer.load({id: this.values}).then(res => {
          this.lawyer = res.data.data
          this.valueId = this.lawyer.associationId
          this.valueTitle = this.lawyer.lawFirm
          if (this.lawyer.photo!== '' && this.lawyer.photo!=null){
            this.fileList = []
            let upLoadImg = {
              name: this.lawyer.name,
              url: 'http://learn.hnlawyer.org' + this.lawyer.photo
            }
            this.fileList.push(upLoadImg)
          }
        })
      }
    },
    // 审核通过
    passCheck () {
      this.loading = true
      let obj = {
        id: this.lawyer.id,
        associationId: this.valueId,
        name: this.lawyer.name,
        code: this.lawyer.code,
        register: '0',
        email: this.lawyer.email
      }
      lawyer.registrationAudit(obj).then(res => {
        this.loading = false
        if (res.data.code===0){
          this.$message.success("操作成功！")
          this.$emit('update:visible', false)
          this.$emit('callFather')
        }else {
          this.$message.warning(res.data.message)
        }
      })
    },
    // 审核不通过
    noPass () {
      this.loading1 = true
      let obj = {
        id: this.lawyer.id,
        associationId: this.valueId,
        name: this.lawyer.name,
        code: this.lawyer.code,
        register: '2',
        email: this.lawyer.email
      }
      lawyer.registrationAudit(obj).then(res => {
        this.loading1 = false
        if (res.data.code===0){
          this.$message.success("操作成功！")
          this.$emit('update:visible', false)
          this.$emit('callFather')
        }else {
          this.$message.warning(res.data.message)
        }
      })
    },
    initHandle(){
      if(this.valueId){
        this.valueTitle = this.$refs.selectTree.getNode(this.valueId).data[this.props.label]     // 初始化显示
        this.$refs.selectTree.setCurrentKey(this.valueId)       // 设置默认选中
        this.defaultExpandedKey = [this.valueId]      // 设置默认展开
      }
      this.initScroll()
    },
    // 初始化滚动条
    initScroll(){
      this.$nextTick(()=>{
        let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0]
        let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar')
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;'
        scrollBar.forEach(ele => ele.style.width = 0)
      })
    },
    // 切换选项
    handleNodeClick(node){
      this.valueTitle = node[this.props.label]
      this.valueId = node[this.props.value]
      this.$emit('getValue',this.valueId)
      this.defaultExpandedKey = []
    },
    // 清除选中
    clearHandle(){
      this.valueTitle = ''
      this.valueId = null
      this.defaultExpandedKey = []
      this.clearSelected()
      this.$emit('getValue',null)
    },
    // 清空选中样式
    clearSelected(){
      let allNode = document.querySelectorAll('#tree-option .el-tree-node')
      allNode.forEach((element)=>element.classList.remove('is-current'))
    },
    // upLoadSuccess(response, file, fileList) {
    //   // console.log(fileList)
    //   let self = this;
    //   if (response.code === 0) {
    //     if(this.upLoadImg){
    //       this.$message({
    //         showClose: true,
    //         message: '上传成功！',
    //         type: 'success'
    //       });
    //     }
    //     let upLoadImg = {
    //       name: file.name,
    //       url: 'http://learn.hnlawyer.org' + response.data
    //     }
    //     this.fileList.push(upLoadImg)
    //     this.lawyer.photo = response.data
    //   } else {
    //     //上传失败清空上传列表
    //     this.$message({
    //       showClose: true,
    //       message: response.msg,
    //       type: 'error'
    //     });
    //   }
    // }
  },
  watch: {
    value(){
      this.valueId = this.value
      this.initHandle()
    }
  },
  created () {
    this.reload()
  }
}
</script>
<style scoped>
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
    height: auto;
    max-height: 274px;
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
  }
  .el-select-dropdown__item.selected{
    font-weight: normal;
  }
  ul li >>>.el-tree .el-tree-node__content{
    height:auto;
    padding: 0 20px;
  }
  .el-tree-node__label{
    font-weight: normal;
  }
  .el-tree >>>.is-current .el-tree-node__label{
    color: #409EFF;
    font-weight: 700;
  }
  .el-tree >>>.is-current .el-tree-node__children .el-tree-node__label{
    color:#606266;
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/lawyer/check/Check.vue